import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-23cd70ea"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "tagNav"
};
var _hoisted_2 = {
  class: "nav-box"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "nav-title"
};
var _hoisted_5 = {
  class: "hot-or-all"
};
var _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 标签导航 "), _createElementVNode("div", _hoisted_2, [_createCommentVNode(" 左边导航文本 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagNav, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass(['nav-title-box', _ctx.isTitle == item.id && 'active']),
      onClick: function onClick($event) {
        return _ctx.tagChangeClick(item.id, item.id);
      }
    }, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1
    /* TEXT */
    )], 10
    /* CLASS, PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))]), _createCommentVNode(" 右边推荐和全部 "), _withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightTag, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "right-item",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.rightTagClick(item.id);
      }
    }, [_createElementVNode("span", {
      class: _normalizeClass(['right-title', _ctx.isRightTag == item.id && 'right-active '])
    }, _toDisplayString(item.title), 3
    /* TEXT, CLASS */
    )], 8
    /* PROPS */
    , _hoisted_6);
  }), 128
  /* KEYED_FRAGMENT */
  ))], 512
  /* NEED_PATCH */
  ), [[_vShow, !_ctx.isShow]])]);
}